import Moment from 'moment'
import PropTypes from 'prop-types'
import { useState, useEffect, useRef, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Events, scroller } from 'react-scroll'
import { toast } from 'react-toastify'
import {
  ENVIO_A_CARGO_COMPRADOR,
  ENVIO_GRATIS,
  RETIRA_COMPRADOR
} from '../../constants/mediosEnviosPagos.js'
import {
  CATEGORIA_FIJA_POR_TIPO,
  CATEGORIAS_EXCLUIDAS_POR_TIPO,
  requiereEstadoProducto
} from '../../constants/publicaciones.js'
import { ESTADO_ACTIVA } from '../../constants/tiendaOficial.js'
import { fechaOcurrioEnUltimosDias } from '../../helpers/dateValidation.js'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import { setModal } from '../../slices/modalSlice'
import { withValidador } from '../hoc/withValidador'
import Metadatos from '../publicaciones/Metadatos'
import InputEAN, { GTIN_KEY, mensajeEanDuplicado } from '../reutilizables/inputEAN/InputEAN'
import { GenericModal } from '../reutilizables/modal/GenericModal'
import * as publicacionService from '../servicios/publicacionesTemporalesService'
import * as tiendasOficialesService from '../servicios/tiendasOficialesService'
import LinkButton from '../ui/LinkButton'
import AgregarFotos from './AgregarFotos'
import AsistenteFlechas from './AsistenteFlechas'
import Borde from './Borde'
import CategoriasPrincipales from './CategoriasPrincipales'
import DescripcionProducto from './DescripcionProducto'
import { getEsquema } from './esquema'
import Exposicion from './exposicion/Exposicion'
import FechaPublicacion from './FechaPublicacion'
import IndicarCategorias from './IndicarCategorias'
import IndicarEtiquetas from './IndicarEtiquetas'
import IndicarPrecio from './IndicarPrecio'
import IndicarProducto from './IndicarProducto'
import IndicarProductoEstado from './IndicarProductoEstado'
import ListaDeVentas from './ListaDeVentas'
import Ofertas from './Ofertas'
import './Publicar.css'
import { PublicacionMasiva } from './PublicacionMasiva'
import TipoPublicacion from './TipoPublicacion'
import VentasEspeciales from './VentasEspeciales'

const CENTER_DIVISOR = 2
const DIAS_MOSTRAR_BORRADOR = 2
const OFFSET = -300
const PASO = {
  PRINCIPIO: -1,
  TITULO: 0,
  EAN: 1,
  DESCRIPCION: 2,
  FECHA_PUBLICACION: 3,
  LISTA_VENTAS: 4,
  ETIQUETAS: 5,
  CATEGORIA: 6,
  CARACTERISTICAS: 7,
  ESTADO_PRODUCTO: 8,
  IMAGENES: 9,
  PRECIO: 10,
  VENTAS_ESPECIALES: 11,
  OFERTA: 12,
  FINAL: 13
}

const MAXIMO_DESCRIPCION = 1000

const Publicar = ({ Validador }) => {
  const navigate = useNavigate()
  const { loginDataContext } = useAuth()
  const { idUsuario, empid, aceptaNoHayDatosFiscales, aceptaTyC, existeDatosFiscales } =
    loginDataContext
  const noCompra = !(aceptaNoHayDatosFiscales || existeDatosFiscales) || !aceptaTyC

  // Initial publicacion object
  const initialPublicacion = {
    alicuota: 0,
    idPublicacionTemporal: 0,
    idVendedor: idUsuario,
    titulo: '',
    descripcion: '',
    desde: Moment().format('YYYY-MM-DD'),
    hasta: '',
    idListaVenta: 0,
    etiquetas: '',
    idCategoria: 0,
    metadatos: [],
    esNuevo: null,
    esScrap: false,
    youtube: '',
    conStock: false,
    conStockAPedido: false,
    conPresupuesto: false,
    cantDisponible: 0,
    cantMinPedido: 0,
    precioUnitario: 0,
    envioGratis: false,
    preciosMayorista: [
      {
        cantidad: 0,
        idUnidadMedida: 0,
        precio: 0,
        id: 0
      }
    ],
    tipoProducionCant: 0,
    tipoProducionUnidad: 0,
    idMoneda: 0,
    capacidadMax: 0,
    extensionGarantia: false,
    mediosPagos: [],
    mediosEnvios: [],
    garantias: [],
    garantiaPlazo: 0,
    garantiaMonto: 0,
    porcDcto: 0,
    ofertaDesde: null,
    ofertaHasta: null,
    idPublicacionExposicion: 0,
    nombreListaEnvio: '',
    cantDiasEnvioGratis: null,
    cantDiasRetiroComprador: null,
    descZona: '',
    descZonaRetiro: '',
    tipoProducto: '',
    esTiendaOficial: false
  }

  // State
  const [errores, setErrores] = useState({})
  const [idPublicacionTemporal, setIdPublicacionTemporal] = useState(0)
  const [paso, setPaso] = useState(PASO.PRINCIPIO)
  const idVendedor = idUsuario || 0
  const [verCategoriasPrincipales, setVerCategoriasPrincipales] = useState(false)
  const [publicacion, setPublicacion] = useState(initialPublicacion)
  const [esMasiva, setEsMasiva] = useState(false)
  const [publicacionTemporal, setPublicacionTemporal] = useState(null)
  const vigenciaManualRef = useRef({
    desde: initialPublicacion.desde,
    hasta: initialPublicacion.hasta
  })
  const dispatch = useDispatch()
  const modalRestaurarAbiertoRef = useRef(false)
  const publicacionesTemporalesRef = useRef([])
  const activoRef = useRef(false)
  const scrollRestauracionRef = useRef(false)
  const pasoRefs = useRef({})
  const pasoRefSetters = useRef({})
  const validacionEanRef = useRef(null)
  const errorEanRef = useRef('')

  const verEstadoProducto = requiereEstadoProducto(publicacion.tipoProducto)
  const [tieneCaracteristicas, setTieneCaracteristicas] = useState(true)

  const getPasoElemento = useCallback((paso) => pasoRefs.current[paso] || null, [])

  const setPasoRef = useCallback((paso) => {
    if (!pasoRefSetters.current[paso]) {
      pasoRefSetters.current[paso] = (p) => {
        pasoRefs.current[paso] = p
      }
    }
    return pasoRefSetters.current[paso]
  }, [])

  // Mount effect
  useEffect(() => {
    Events.scrollEvent.register('begin', () => {})

    Events.scrollEvent.register('end', (to) => {
      to === 'pasoArriba' && setVerCategoriasPrincipales(false)
    })

    return () => {
      Events.scrollEvent.remove('begin')
      Events.scrollEvent.remove('end')
      document.body.classList.remove('sin-scroll')
    }
  }, [])

  const getAlto = useCallback(
    (pasoNum) => {
      const refPasoActual = getPasoElemento(pasoNum)
      const refPasoAnterior = getPasoElemento(pasoNum - 1)

      if (refPasoActual && refPasoAnterior) {
        return (refPasoActual.offsetHeight - refPasoAnterior.offsetHeight) / CENTER_DIVISOR
      }
      return 0
    },
    [getPasoElemento]
  )

  const getAltos = useCallback(
    (cantPasos) => {
      let offSetCalc = 0
      for (let i = 0; i < cantPasos; i++) {
        offSetCalc += getAlto(cantPasos - i)
      }
      return offSetCalc
    },
    [getAlto]
  )

  const moverScroll = useCallback(() => {
    if (paso <= PASO.FINAL) {
      const offSetCalc = OFFSET + getAltos(paso)

      scroller.scrollTo('borde-normal-active', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: offSetCalc
      })
    }
  }, [paso, getAltos])

  const enfocarCampo = useCallback(
    (pasoDestino) => {
      const contenedor = getPasoElemento(pasoDestino)
      if (!contenedor) {
        return
      }

      const candidatos = contenedor.querySelectorAll(
        'input[type="text"], input[type="number"], input:not([type]), textarea'
      )

      const campo = Array.from(candidatos).find((elemento) => {
        if (elemento.disabled || elemento.hidden) {
          return false
        }
        return elemento.offsetParent !== null
      })

      campo?.focus({ preventScroll: true })
    },
    [getPasoElemento]
  )

  const tieneTiendaOficial = async () => {
    const { data: tienda } = await tiendasOficialesService.buscarPorEmpresa(empid)
    if (tienda.idTiendaOficial && tienda.idTiendaOficialEstado === ESTADO_ACTIVA) {
      setPublicacion((prev) => ({ ...prev, esTiendaOficial: true }))
      setPublicacionTemporal((prev) => ({ ...prev, esTiendaOficial: true }))
    }
  }

  const openConfirm = (publicaciones) => {
    if (modalRestaurarAbiertoRef.current) {
      return
    }

    modalRestaurarAbiertoRef.current = true

    dispatch(
      setModal({
        size: 'sm',
        title: 'Elegir publicación para restaurar',
        type: 'items',
        items: publicaciones.map((publicacion) => {
          const publicacionGuardada = JSON.parse(publicacion.publicacion)
          return {
            value: publicacion.idPublicacionTemporal,
            label: publicacionGuardada?.titulo || 'Publicación sin título'
          }
        }),
        body: 'No hay publicaciones temporales recientes.',
        show: true,
        modalId: 'restaurar-publicacion'
      })
    )
  }

  useEffect(() => {
    if (!idVendedor) {
      return
    }

    tieneTiendaOficial()
    activoRef.current = true
    obtenerPublicacionPendiente()
    return () => {
      activoRef.current = false
    }
  }, [idVendedor])

  const obtenerPublicacionPendiente = async () => {
    const { data } = await publicacionService.obtenerUltimasNoPublicadas(idVendedor)

    if (!Array.isArray(data) || !data.length) {
      return
    }

    const publicacionesRecientes = data.filter((publicacion) => {
      const fechaPublicacion = JSON.parse(publicacion.publicacion).fechaPublicacion
      return fechaOcurrioEnUltimosDias(fechaPublicacion, DIAS_MOSTRAR_BORRADOR)
    })

    if (!publicacionesRecientes.length || !activoRef.current) {
      return
    }

    publicacionesTemporalesRef.current = publicacionesRecientes
    setPublicacionTemporal(null)
    openConfirm(publicacionesRecientes)
  }

  const restaurarPublicacion = (item) => {
    const publicacionSeleccionada = item?.publicacion
      ? item
      : item
        ? publicacionesTemporalesRef.current.find(
            (publicacion) => publicacion.idPublicacionTemporal === item.value
          )
        : publicacionTemporal

    if (!publicacionSeleccionada?.idPublicacionTemporal) {
      return true
    }

    const publicacionGuardada = JSON.parse(publicacionSeleccionada.publicacion)
    const pubFinal = {
      ...initialPublicacion,
      ...publicacionGuardada,
      idVendedor: idVendedor
    }
    setIdPublicacionTemporal(publicacionSeleccionada.idPublicacionTemporal)
    setPublicacion(pubFinal)
    setPaso(PASO.TITULO)
    scrollRestauracionRef.current = true
    dispatch(setModal({ show: false }))
    return true
  }

  const seleccionarPublicacion = (item) => {
    const seleccionada = publicacionesTemporalesRef.current.find(
      (publicacion) => publicacion.idPublicacionTemporal === item.value
    )
    if (seleccionada) {
      setPublicacionTemporal(seleccionada)
      restaurarPublicacion(seleccionada)
    }
  }

  const eliminarBorrador = async (item) => {
    const borradorId = item?.value ?? publicacionTemporal?.idPublicacionTemporal

    if (!borradorId) {
      return false
    }

    try {
      await publicacionService.eliminarPublicacionTemporal(borradorId)
      toast.success('El borrador se ha eliminado correctamente.')

      const publicacionesRestantes = publicacionesTemporalesRef.current.filter(
        (publicacionItem) => publicacionItem.idPublicacionTemporal !== borradorId
      )

      publicacionesTemporalesRef.current = publicacionesRestantes

      if (publicacionTemporal?.idPublicacionTemporal === borradorId) {
        setPublicacionTemporal(null)
      }

      if (publicacionesRestantes.length) {
        dispatch(
          setModal({
            size: 'sm',
            title: 'Elegir publicación para restaurar',
            type: 'items',
            items: publicacionesRestantes.map((publicacionItem) => {
              const publicacionGuardada = JSON.parse(publicacionItem.publicacion)
              return {
                value: publicacionItem.idPublicacionTemporal,
                label: publicacionGuardada?.titulo || 'Publicación sin título'
              }
            }),
            body: 'No hay publicaciones temporales recientes.',
            show: true,
            modalId: 'restaurar-publicacion'
          })
        )
      } else {
        handleCerrarModalRestaurar()
      }

      return true
    } catch (error) {
      const mensaje = 'Ocurrió un error al eliminar el borrador.'
      toastErrorLog(error, mensaje, 'publicaciones')
      return false
    }
  }

  const eliminarTodosLosBorradores = async () => {
    const borradores = [...publicacionesTemporalesRef.current]

    if (!borradores.length) {
      return false
    }

    try {
      await Promise.all(
        borradores.map((borrador) =>
          publicacionService.eliminarPublicacionTemporal(borrador.idPublicacionTemporal)
        )
      )

      publicacionesTemporalesRef.current = []
      setPublicacionTemporal(null)
      toast.success('Todos los borradores se han eliminado correctamente.')
      handleCerrarModalRestaurar()
      return true
    } catch (error) {
      const mensaje = 'Ocurrió un error al eliminar los borradores.'
      toastErrorLog(error, mensaje, 'publicaciones')
      return false
    }
  }

  const handleCerrarModalRestaurar = () => {
    modalRestaurarAbiertoRef.current = false
    setPublicacionTemporal(null)
    dispatch(setModal({ show: false, modalId: 'restaurar-publicacion' }))
  }

  useEffect(() => {
    if (scrollRestauracionRef.current) {
      requestAnimationFrame(() => {
        const refDestino = getPasoElemento(paso)

        if (refDestino) {
          refDestino.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }

        scrollRestauracionRef.current = false
      })
      return
    }

    if (paso === PASO.PRINCIPIO) {
      scroller.scrollTo('pasoArriba', {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -150
      })
      return
    }

    moverScroll()
    enfocarCampo(paso)
  }, [paso, moverScroll, getPasoElemento, enfocarCampo])

  const handleTipoPublicacion = (masiva) => {
    setVerCategoriasPrincipales(true)
    setTimeout(() => {
      scroller.scrollTo('divCategorias', {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: 0
      })
    }, 0)
    setEsMasiva(masiva)
    if (masiva !== esMasiva) {
      setPublicacion(initialPublicacion)
      setPaso(PASO.TITULO)
    }
  }

  const calcularPaso = (pasoActual, siguiente) => {
    let destino = pasoActual + (siguiente ? 1 : -1)
    if (!tieneCaracteristicas && destino === PASO.CARACTERISTICAS) {
      destino += siguiente ? 1 : -1
    }
    if (!verEstadoProducto && destino === PASO.ESTADO_PRODUCTO) {
      destino += siguiente ? 1 : -1
    }
    return destino
  }

  const irAPaso = (siguiente) => {
    setPaso((prevPaso) => calcularPaso(prevPaso, siguiente))
  }

  const handlePasoAnterior = () => {
    const pasoAnterior = calcularPaso(paso, false)
    irAPaso(false)

    setTimeout(() => {
      const prevRef = getPasoElemento(pasoAnterior)
      if (prevRef) {
        prevRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 0)
    submit()
  }

  const irAPasoConError = (pasoError) => {
    setPaso(pasoError)
    setTimeout(() => {
      const ref = getPasoElemento(pasoError)
      if (ref) {
        ref.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 0)
  }

  const pasoValido = useCallback(
    (name, value, cambios = {}) => {
      const datosActualizados = {
        ...publicacion,
        ...cambios,
        [name]: value
      }
      const datosParaValidarBase =
        value === undefined ? { ...publicacion, ...cambios } : datosActualizados

      const datosParaValidar = {
        ...datosParaValidarBase,
        requiereEstadoProducto: requiereEstadoProducto(datosParaValidarBase.tipoProducto),
        tieneRetiro: datosParaValidarBase.mediosEnvios?.some(
          (m) => m.idMedioEnvio === RETIRA_COMPRADOR
        ),
        tieneEnvioGratis: datosParaValidarBase.mediosEnvios?.some(
          (m) => m.idMedioEnvio === ENVIO_GRATIS
        )
      }
      const erroresValidation = Validador.validarDato(getEsquema(), datosParaValidar, name)

      setErrores((prev) => {
        const nuevosErrores = { ...prev }
        if (erroresValidation?.[name]) {
          nuevosErrores[name] = erroresValidation[name]
        } else {
          delete nuevosErrores[name]
        }
        return nuevosErrores
      })
      if (erroresValidation) {
        return false
      } else {
        return true
      }
    },
    [publicacion, Validador]
  )

  const valido = useCallback(
    (pasoNum, name) => (paso === pasoNum && !pasoValido(name) ? false : true),
    [paso, pasoValido]
  )

  const handlePasoSiguiente = async () => {
    if (paso === PASO.TITULO) {
      Validador.cargarEsquema(getEsquema())
    }

    if (!valido(PASO.TITULO, 'titulo')) {
      return
    }

    if (paso === PASO.EAN) {
      if (typeof document !== 'undefined') {
        document.activeElement?.blur?.()
      }
      if (validacionEanRef.current) {
        await validacionEanRef.current
      }
      if (errorEanRef.current) {
        return
      }
    }
    if (!valido(PASO.DESCRIPCION, 'descripcion')) {
      return
    }
    if (!valido(PASO.FECHA_PUBLICACION, 'desde') || !valido(PASO.FECHA_PUBLICACION, 'hasta')) {
      return
    }
    if (!valido(PASO.CATEGORIA, 'idCategoria')) {
      return
    }
    if (verEstadoProducto && !valido(PASO.ESTADO_PRODUCTO, 'esNuevo')) {
      return
    }
    if (
      !valido(PASO.PRECIO, 'idMoneda') ||
      !valido(PASO.PRECIO, 'precioUnitario') ||
      !valido(PASO.PRECIO, 'alicuota') ||
      !valido(PASO.PRECIO, 'cantDisponible') ||
      !valido(PASO.PRECIO, 'cantMinPedido') ||
      !valido(PASO.PRECIO, 'capacidadMax') ||
      !valido(PASO.PRECIO, 'tipoProducionCant') ||
      !valido(PASO.PRECIO, 'tipoProducionUnidad')
    ) {
      return
    }

    if (
      !valido(PASO.OFERTA, 'porcDcto') ||
      !valido(PASO.OFERTA, 'ofertaDesde') ||
      !valido(PASO.OFERTA, 'ofertaHasta')
    ) {
      return
    }
    if (
      !valido(PASO.VENTAS_ESPECIALES, 'mediosPagos') ||
      !valido(PASO.VENTAS_ESPECIALES, 'mediosEnvios') ||
      !valido(PASO.VENTAS_ESPECIALES, 'cantDiasEnvioGratis') ||
      !valido(PASO.VENTAS_ESPECIALES, 'cantDiasRetiroComprador') ||
      !valido(PASO.VENTAS_ESPECIALES, 'descZona') ||
      !valido(PASO.VENTAS_ESPECIALES, 'descZonaRetiro')
    ) {
      return
    }

    if (publicacion.mediosEnvios.some((m) => m.idMedioEnvio === ENVIO_A_CARGO_COMPRADOR)) {
      if (!publicacion.idListaEnvio || publicacion.idListaEnvio === 0) {
        setErrores((prev) => ({
          ...prev,
          idListaEnvio: 'Debe seleccionar una lista de envíos.'
        }))
        irAPasoConError(PASO.VENTAS_ESPECIALES)
        return
      }
    }

    if (paso < PASO.FINAL) {
      irAPaso(true)
    }

    setTimeout(() => {
      const nextRef = getPasoElemento(calcularPaso(paso, true))
      if (nextRef) {
        nextRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 0)
    submit()
  }

  const obtenerValor = (value, valueCalculado, checked, type, tipoDato) => {
    let val
    switch (tipoDato) {
      case 'bool':
        val = value === 'true'
        break
      case 'num':
        val = Number(value)
        break
      case 'calc':
        val = valueCalculado
        break
      default:
        val = type === 'checkbox' || type === 'radio' ? checked : value
        break
    }
    return val
  }

  const handleChangeState = (name, value, callBack) => {
    setPublicacion((prevState) => ({
      ...prevState,
      [name]: value
    }))
    if (callBack) {
      callBack()
    }
  }

  const setErrorEAN = (mensaje) => {
    errorEanRef.current = mensaje
    setErrores((prev) => {
      const nuevosErrores = { ...prev }
      if (mensaje) {
        nuevosErrores.ean = mensaje
      } else {
        delete nuevosErrores.ean
      }
      return nuevosErrores
    })
  }

  const handleChangeEAN = (nuevoValor) => {
    const metadatos = [...(publicacion.metadatos || [])]
    const index = metadatos.findIndex((m) => m.idMetadato === GTIN_KEY)

    if (!nuevoValor) {
      if (index !== -1) metadatos.splice(index, 1)
    } else if (index !== -1) {
      metadatos[index] = { idMetadato: GTIN_KEY, valor: nuevoValor }
    } else {
      metadatos.push({ idMetadato: GTIN_KEY, valor: nuevoValor })
    }
    handleChangeState('metadatos', metadatos)
    if (errores.ean) setErrorEAN('')
  }

  const handleBlurEAN = ({ errorFormato, duplicada }) => {
    if (errorFormato) {
      setErrorEAN(errorFormato)
    } else if (duplicada) {
      setErrorEAN(mensajeEanDuplicado(duplicada))
    } else {
      setErrorEAN('')
    }
  }

  const handleChange = ({ currentTarget: input }, tipoDato = '', valueCalculado = null) => {
    const { name, value, checked, type } = input
    let nuevoValor = obtenerValor(value, valueCalculado, checked, type, tipoDato)

    if (name === 'descripcion' && typeof nuevoValor === 'string') {
      nuevoValor = nuevoValor.slice(0, MAXIMO_DESCRIPCION)
    }

    if (name === 'descZona' || name === 'descZonaRetiro') {
      setPublicacion((prevState) => ({
        ...prevState,
        [name]: nuevoValor
      }))
    } else if (name === 'cantDiasEnvioGratis' || name === 'cantDiasRetiroComprador') {
      const valorDias =
        value === '' || value === null || value === undefined ? null : parseInt(value, 10)
      setPublicacion((prevState) => ({
        ...prevState,
        [name]: Number.isNaN(valorDias) ? null : valorDias
      }))
    } else {
      pasoValido(input.name, nuevoValor)
      moverScroll()
      handleChangeState(name, nuevoValor, () => {
        pasoValido(name, nuevoValor)
        if (name === 'cantMinPedido') {
          pasoValido('capacidadMax', publicacion.capacidadMax, { cantMinPedido: nuevoValor })
        }
        if (name === 'capacidadMax') {
          pasoValido('cantMinPedido', publicacion.cantMinPedido, { capacidadMax: nuevoValor })
        }
      })

      if ((name === 'desde' || name === 'hasta') && !Number(publicacion.idListaVenta)) {
        vigenciaManualRef.current = {
          ...vigenciaManualRef.current,
          [name]: nuevoValor
        }
      }
    }
  }

  const handleListaVentaChange = (listaSeleccionada) => {
    setPublicacion((prevState) => {
      if (listaSeleccionada && Number(listaSeleccionada.value) > 0) {
        if (!Number(prevState.idListaVenta)) {
          vigenciaManualRef.current = {
            desde: prevState.desde,
            hasta: prevState.hasta
          }
        }

        return {
          ...prevState,
          desde: listaSeleccionada.vigenciaDesde || prevState.desde,
          hasta: listaSeleccionada.vigenciaHasta || prevState.hasta
        }
      }

      if (Number(prevState.idListaVenta)) {
        return {
          ...prevState,
          desde: vigenciaManualRef.current.desde || prevState.desde,
          hasta: vigenciaManualRef.current.hasta || prevState.hasta
        }
      }

      return prevState
    })
  }

  useEffect(() => {
    if (!Number(publicacion.idListaVenta)) {
      vigenciaManualRef.current = {
        desde: publicacion.desde,
        hasta: publicacion.hasta
      }
    }
  }, [publicacion.idListaVenta, publicacion.desde, publicacion.hasta])

  const handleGarantia = (name, value) => {
    setPublicacion((prevState) => ({
      ...prevState,
      [name]: value
    }))
  }

  const submit = async () => {
    const publicacionData = {
      ...publicacion,
      idVendedor: idVendedor,
      cantDiasEnvioGratis: publicacion.cantDiasEnvioGratis
        ? parseInt(publicacion.cantDiasEnvioGratis, 10)
        : null,
      cantDiasRetiroComprador: publicacion.cantDiasRetiroComprador
        ? parseInt(publicacion.cantDiasRetiroComprador, 10)
        : null,
      fechaPublicacion: new Date().toISOString()
    }

    const publicacionPayload = {
      publicacion: JSON.stringify(publicacionData),
      idPublicacionTemporal: idPublicacionTemporal,
      idVendedor: idVendedor
    }

    if (idPublicacionTemporal === 0) {
      const { data } = await publicacionService.insertar(publicacionPayload)
      setIdPublicacionTemporal(data.idPublicacionTemporal)
      setPublicacion((prevState) => ({
        ...prevState,
        idPublicacionTemporal: data.idPublicacionTemporal
      }))
    } else {
      await publicacionService.actualizar(publicacionPayload)
    }
  }

  const handlerPublicar = async () => {
    try {
      if (!pasoValido('idPublicacionExposicion')) {
        return
      }

      if (Object.keys(errores).length) {
        return false
      }

      await publicacionService.publicar(publicacion)
      limpiarForm()

      navigate('/PublicacionGrabada')
    } catch (error) {
      const mensaje = `Ocurrió un error al publicar.`
      toastErrorLog(error, mensaje, 'publicaciones')
    }
  }

  const limpiarForm = () => {
    setErrores({})
    setIdPublicacionTemporal(0)
    setPaso(PASO.PRINCIPIO)
    setVerCategoriasPrincipales(false)
    setPublicacion(initialPublicacion)
  }

  const claseActivo = (posicion) => (paso === posicion ? true : false)

  const getErrores = (arrElementos) => {
    let error = null
    arrElementos.forEach((e) => {
      if (errores[e]) {
        error = errores[e]
      }
    })
    return error
  }

  const handleTab = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault()
      handlePasoSiguiente()
    }
    if (e.shiftKey && e.key === 'Tab') {
      e.preventDefault()
      handlePasoAnterior()
    }
  }

  const setCatalogo = (tipoValue) => {
    if (!tipoValue) {
      return
    }

    const pideEstado = requiereEstadoProducto(tipoValue.nombre)

    setPublicacion((prev) => ({
      ...prev,
      esScrap: tipoValue.esScrap,
      tipoProducto: tipoValue.nombre,
      idCategoria: prev.tipoProducto === tipoValue.nombre ? prev.idCategoria : 0,
      esNuevo: pideEstado ? (requiereEstadoProducto(prev.tipoProducto) ? prev.esNuevo : null) : true
    }))
    setErrores((prev) => {
      if (pideEstado || !prev.esNuevo) {
        return prev
      }
      return Object.fromEntries(Object.entries(prev).filter(([clave]) => clave !== 'esNuevo'))
    })
    setPaso(PASO.TITULO)
  }

  return noCompra ? (
    <main className="publicar-bloqueado" aria-labelledby="publicar-bloqueado-titulo">
      <div className="publicar-bloqueado__contenido">
        <span className="publicar-bloqueado__icono" aria-hidden="true">
          !
        </span>
        <h1 id="publicar-bloqueado-titulo">Aún no podés publicar</h1>
        <p>
          Para publicar tenés que haber cargado datos fiscales o indicar que aceptas las
          condiciones.
        </p>
        <button
          className="publicar-bloqueado__accion"
          type="button"
          onClick={() => navigate('/Perfil')}
        >
          Ir a mi perfil
        </button>
      </div>
    </main>
  ) : (
    <form onSubmit={(e) => e.preventDefault()} onKeyDown={(e) => handleTab(e)}>
      <div className="pasoArriba">
        <div className="box-publicar">
          <h1 className="titulo-publicar">Nueva publicación</h1>
        </div>

        <div className="seleccion-seccion">
          <p className="seleccion-seccion-titulo">¿Cómo querés publicar?</p>
          <TipoPublicacion
            onClick={handleTipoPublicacion}
            seleccionado={verCategoriasPrincipales ? esMasiva : undefined}
          />
        </div>

        {verCategoriasPrincipales && (
          <div className="seleccion-seccion divCategorias">
            <p className="seleccion-seccion-titulo">¿Qué querés publicar?</p>
            <CategoriasPrincipales onClick={setCatalogo} selectedTipo={publicacion.tipoProducto} />
          </div>
        )}
        {paso >= PASO.TITULO &&
          publicacion.tipoProducto &&
          (esMasiva ? (
            <PublicacionMasiva
              errores={errores}
              handleChange={handleChange}
              esScrap={publicacion.esScrap}
              categoriaFija={CATEGORIA_FIJA_POR_TIPO[publicacion.tipoProducto]}
              categoriasExcluidas={CATEGORIAS_EXCLUIDAS_POR_TIPO[publicacion.tipoProducto]}
            />
          ) : (
            <div className="row">
              <div>
                <Borde
                  titulo="Indicá el título de tu publicación"
                  activo={claseActivo(PASO.TITULO)}
                  ref={setPasoRef(PASO.TITULO)}
                  error={errores.titulo}
                >
                  <IndicarProducto onChange={handleChange} value={publicacion.titulo} />
                </Borde>
                <Borde
                  titulo="Ingresá el código EAN del producto (Opcional)"
                  activo={claseActivo(PASO.EAN)}
                  ref={setPasoRef(PASO.EAN)}
                  error={errores.ean}
                >
                  <InputEAN
                    value={
                      publicacion.metadatos?.find((m) => m.idMetadato === GTIN_KEY)?.valor ?? ''
                    }
                    idVendedor={idVendedor}
                    onChange={handleChangeEAN}
                    onBlur={handleBlurEAN}
                    onCheckError={() =>
                      toastErrorLog(null, 'Ocurrió un error al verificar el EAN.', 'ean')
                    }
                    onValidatingChange={(promesa) => {
                      validacionEanRef.current = promesa
                    }}
                    error={errores.ean}
                    placeholder="Ej: 7622201735296"
                    descripcion="Ingresá el código EAN (código de barras) del producto. Debe ser un EAN-8 o EAN-13 válido."
                  />
                </Borde>
                <Borde
                  titulo="Escribí la descripción de tu publicación"
                  activo={claseActivo(PASO.DESCRIPCION)}
                  ref={setPasoRef(PASO.DESCRIPCION)}
                  error={errores.descripcion}
                >
                  <DescripcionProducto onChange={handleChange} value={publicacion.descripcion} />
                </Borde>
                <Borde
                  titulo="Fecha de Publicación"
                  activo={claseActivo(PASO.FECHA_PUBLICACION)}
                  ref={setPasoRef(PASO.FECHA_PUBLICACION)}
                  error={errores.desde ? errores.desde : errores.hasta}
                >
                  <FechaPublicacion onChange={handleChange} publicacion={publicacion} />
                </Borde>
                <Borde
                  titulo="Lista de Ventas"
                  activo={claseActivo(PASO.LISTA_VENTAS)}
                  ref={setPasoRef(PASO.LISTA_VENTAS)}
                >
                  <ListaDeVentas
                    idVendedor={idVendedor}
                    onChange={handleChange}
                    onChangeState={handleChangeState}
                    onListaVentaChange={handleListaVentaChange}
                    onEliminarLista={() => irAPaso(false)}
                    value={publicacion.idListaVenta}
                  />
                </Borde>
                <Borde
                  titulo="Indicá las etiquetas de tu publicación"
                  activo={claseActivo(PASO.ETIQUETAS)}
                  ref={setPasoRef(PASO.ETIQUETAS)}
                >
                  <IndicarEtiquetas
                    onChangeState={handleChangeState}
                    value={publicacion.etiquetas}
                  />
                </Borde>
                <Borde
                  titulo="Indicá a que categoría pertenece"
                  activo={claseActivo(PASO.CATEGORIA)}
                  ref={setPasoRef(PASO.CATEGORIA)}
                  error={errores.idCategoria}
                >
                  <IndicarCategorias
                    onChange={handleChange}
                    value={publicacion.idCategoria}
                    esScrap={publicacion.esScrap}
                    categoriaFija={CATEGORIA_FIJA_POR_TIPO[publicacion.tipoProducto]}
                    categoriasExcluidas={CATEGORIAS_EXCLUIDAS_POR_TIPO[publicacion.tipoProducto]}
                  />
                </Borde>
                <Borde
                  titulo="Indicá las características de tu publicación"
                  activo={claseActivo(PASO.CARACTERISTICAS)}
                  ref={setPasoRef(PASO.CARACTERISTICAS)}
                  className={tieneCaracteristicas ? '' : 'd-none'}
                >
                  <Metadatos
                    value={{ metadatos: publicacion.metadatos }}
                    idCategoria={publicacion.idCategoria}
                    esPublicar={true}
                    editable={true}
                    onChange={handleChange}
                    onMetadatosCargados={(cantidad) => {
                      setTieneCaracteristicas(cantidad > 0)
                      if (cantidad > 0 && paso === PASO.CARACTERISTICAS) {
                        requestAnimationFrame(() => enfocarCampo(PASO.CARACTERISTICAS))
                      }
                    }}
                  />
                </Borde>
                {verEstadoProducto && (
                  <Borde
                    titulo="Indicá el estado de tu publicación"
                    activo={claseActivo(PASO.ESTADO_PRODUCTO)}
                    ref={setPasoRef(PASO.ESTADO_PRODUCTO)}
                    error={errores.esNuevo}
                  >
                    <IndicarProductoEstado onChange={handleChange} checked={publicacion.esNuevo} />
                  </Borde>
                )}
                <Borde
                  titulo="Agregá las fotos de tu publicación"
                  activo={claseActivo(PASO.IMAGENES)}
                  ref={setPasoRef(PASO.IMAGENES)}
                >
                  <AgregarFotos
                    value={publicacion.youtube}
                    idPublicacion={0}
                    idPublicacionTemporal={
                      idPublicacionTemporal || publicacion.idPublicacionTemporal
                    }
                    onChange={handleChange}
                  />
                </Borde>
                <Borde
                  titulo="Indicá el precio de tu publicación"
                  activo={claseActivo(PASO.PRECIO)}
                  ref={setPasoRef(PASO.PRECIO)}
                  error={getErrores([
                    'cantDisponible',
                    'cantMinPedido',
                    'capacidadMax',
                    'tipoProducionCant',
                    'tipoProducionUnidad',
                    'precioUnitario',
                    'idMoneda',
                    'alicuota'
                  ])}
                >
                  <IndicarPrecio
                    values={{
                      conStock: publicacion.conStock,
                      conStockAPedido: publicacion.conStockAPedido,
                      conPresupuesto: publicacion.conPresupuesto,
                      cantDisponible: publicacion.cantDisponible,
                      cantMinPedido: publicacion.cantMinPedido,
                      precioUnitario: publicacion.precioUnitario,
                      idMoneda: publicacion.idMoneda,
                      preciosMayorista: publicacion.preciosMayorista,
                      capacidadMax: publicacion.capacidadMax,
                      alicuota: publicacion.alicuota,
                      tipoProducionCant: publicacion.tipoProducionCant,
                      tipoProducionUnidad: publicacion.tipoProducionUnidad
                    }}
                    onChange={handleChange}
                    onChangeState={handleChangeState}
                  />
                </Borde>
                <Borde
                  titulo="Condiciones de Venta Especiales"
                  activo={claseActivo(PASO.VENTAS_ESPECIALES)}
                  ref={setPasoRef(PASO.VENTAS_ESPECIALES)}
                  error={getErrores([
                    'mediosPagos',
                    'mediosEnvios',
                    'envioGratis',
                    'idListaEnvio',
                    'cantDiasEnvioGratis',
                    'cantDiasRetiroComprador',
                    'descZona',
                    'descZonaRetiro'
                  ])}
                >
                  <VentasEspeciales
                    values={{
                      extensionGarantia: publicacion.extensionGarantia,
                      garantiaPlazo: publicacion.garantiaPlazo,
                      garantiaMonto: publicacion.garantiaMonto,
                      mediosPagos: publicacion.mediosPagos,
                      mediosEnvios: publicacion.mediosEnvios,
                      garantias: publicacion.garantias,
                      envioGratis: publicacion.envioGratis,
                      nombreListaEnvio: publicacion.nombreListaEnvio,
                      idListaEnvio: publicacion.idListaEnvio,
                      descZona: publicacion.descZona,
                      descZonaRetiro: publicacion.descZonaRetiro,
                      cantDiasEnvioGratis: publicacion.cantDiasEnvioGratis,
                      cantDiasRetiroComprador: publicacion.cantDiasRetiroComprador
                    }}
                    onChange={handleChange}
                    onAddGarantia={handleGarantia}
                  />
                </Borde>
                <Borde
                  titulo="Oferta!"
                  activo={claseActivo(PASO.OFERTA)}
                  ref={setPasoRef(PASO.OFERTA)}
                  error={
                    errores.porcDcto
                      ? errores.porcDcto
                      : errores.ofertaDesde
                        ? errores.ofertaDesde
                        : errores.ofertaHasta
                  }
                >
                  <Ofertas
                    values={{
                      porcDcto: publicacion.porcDcto,
                      precioUnitario: publicacion.precioUnitario,
                      alicuota: publicacion.alicuota,
                      ofertaDesde: publicacion.ofertaDesde,
                      ofertaHasta: publicacion.ofertaHasta
                    }}
                    onChange={handleChange}
                  />
                </Borde>
                <Borde
                  titulo="Indicá la exposición de tu publicación"
                  activo={claseActivo(PASO.FINAL)}
                  ref={setPasoRef(PASO.FINAL)}
                  error={errores.idPublicacionExposicion}
                >
                  <Exposicion
                    onChange={handleChange}
                    checked={publicacion.idPublicacionExposicion}
                    precioUnitario={publicacion.precioUnitario}
                  />
                </Borde>
                {paso >= PASO.TITULO && (
                  <div className="row">
                    <div className="col-2 d-none d-lg-block"></div>
                    <div className="col">
                      <LinkButton className="btn-finalizar-publicacion" onClick={handlerPublicar}>
                        Finalizar la Publicación
                      </LinkButton>
                      <div style={{ marginBottom: '300px' }} />
                    </div>
                    <div className="col-2 d-none d-lg-block"></div>
                  </div>
                )}
              </div>
              <div className="col-12 p-0">
                <AsistenteFlechas
                  clickPasoAnterior={handlePasoAnterior}
                  clickPasoSiguiente={handlePasoSiguiente}
                  limiteInferior={paso === PASO.FINAL}
                  esPasoCero={paso === PASO.TITULO}
                ></AsistenteFlechas>
              </div>
            </div>
          ))}
      </div>
      <GenericModal
        modalId="restaurar-publicacion"
        onSelect={seleccionarPublicacion}
        onDelete={eliminarBorrador}
        onDeleteAll={eliminarTodosLosBorradores}
        onClose={handleCerrarModalRestaurar}
      />
    </form>
  )
}

Publicar.propTypes = {
  Validador: PropTypes.shape({
    validarDato: PropTypes.func.isRequired,
    cargarEsquema: PropTypes.func.isRequired
  }).isRequired
}

export default withValidador(Publicar)
